(function (window, document, $) {
    'use strict';

    const getBreakpoint = function () {
        return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
    };

    $(function () {


        $('.offcanvas-nav .dropdown').on('show.bs.dropdown', function (evt) {
            const breakpoint = getBreakpoint();
            if (breakpoint === 'lg' || breakpoint === 'xl') {
                $(this).children('.dropdown-menu').css('left', 0);
            } else {
                var offsetLeft = $(this).width();
                $(this).children('.dropdown-menu').css('left', offsetLeft);
            }
        });
    });
}(window, document, jQuery));